// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2Z8PK","content":"Consent_content__3uJJa","footer":"Consent_footer__2M2NP"};